import React from 'react'
import "../../styles/home.css"

const Footer = () => {
  return (
    <div>
  <div className="end">
  <a href="https://in.linkedin.com/in/amanchandra1" target="main"><h4 style={{color: 'rgb(255 255 255)'}}>
      Made By - Aman Chandra
    </h4></a>
  <a href="https://in.linkedin.com/in/amanchandra1" target="main"><img className="img" src="/Resources/linkedin.png" alt="Linkedin" /></a>
</div>

    </div>
  )
}

export default Footer
